var map = {
	"./image/levelS/amusement/amusement(1).PNG": 89,
	"./image/levelS/amusement/amusement(10).PNG": 169,
	"./image/levelS/amusement/amusement(11).PNG": 170,
	"./image/levelS/amusement/amusement(12).PNG": 171,
	"./image/levelS/amusement/amusement(13).PNG": 172,
	"./image/levelS/amusement/amusement(14).PNG": 173,
	"./image/levelS/amusement/amusement(15).PNG": 174,
	"./image/levelS/amusement/amusement(16).PNG": 175,
	"./image/levelS/amusement/amusement(17).PNG": 176,
	"./image/levelS/amusement/amusement(18).PNG": 177,
	"./image/levelS/amusement/amusement(19).PNG": 178,
	"./image/levelS/amusement/amusement(2).PNG": 179,
	"./image/levelS/amusement/amusement(20).PNG": 180,
	"./image/levelS/amusement/amusement(21).PNG": 181,
	"./image/levelS/amusement/amusement(22).PNG": 182,
	"./image/levelS/amusement/amusement(23).PNG": 183,
	"./image/levelS/amusement/amusement(24).PNG": 184,
	"./image/levelS/amusement/amusement(25).PNG": 185,
	"./image/levelS/amusement/amusement(26).PNG": 186,
	"./image/levelS/amusement/amusement(27).PNG": 187,
	"./image/levelS/amusement/amusement(3).PNG": 188,
	"./image/levelS/amusement/amusement(4).PNG": 189,
	"./image/levelS/amusement/amusement(5).PNG": 190,
	"./image/levelS/amusement/amusement(6).PNG": 191,
	"./image/levelS/amusement/amusement(7).PNG": 192,
	"./image/levelS/amusement/amusement(8).PNG": 193,
	"./image/levelS/amusement/amusement(9).PNG": 194,
	"./image/levelS/cockroach/cockroach(1).PNG": 90,
	"./image/levelS/cockroach/cockroach(10).PNG": 195,
	"./image/levelS/cockroach/cockroach(11).PNG": 196,
	"./image/levelS/cockroach/cockroach(12).PNG": 197,
	"./image/levelS/cockroach/cockroach(13).PNG": 198,
	"./image/levelS/cockroach/cockroach(14).PNG": 199,
	"./image/levelS/cockroach/cockroach(15).PNG": 200,
	"./image/levelS/cockroach/cockroach(16).PNG": 201,
	"./image/levelS/cockroach/cockroach(17).PNG": 202,
	"./image/levelS/cockroach/cockroach(18).PNG": 203,
	"./image/levelS/cockroach/cockroach(19).PNG": 204,
	"./image/levelS/cockroach/cockroach(2).PNG": 205,
	"./image/levelS/cockroach/cockroach(20).PNG": 206,
	"./image/levelS/cockroach/cockroach(21).PNG": 207,
	"./image/levelS/cockroach/cockroach(22).PNG": 208,
	"./image/levelS/cockroach/cockroach(23).PNG": 209,
	"./image/levelS/cockroach/cockroach(24).PNG": 210,
	"./image/levelS/cockroach/cockroach(25).PNG": 211,
	"./image/levelS/cockroach/cockroach(26).PNG": 212,
	"./image/levelS/cockroach/cockroach(27).PNG": 213,
	"./image/levelS/cockroach/cockroach(28).PNG": 214,
	"./image/levelS/cockroach/cockroach(3).PNG": 215,
	"./image/levelS/cockroach/cockroach(4).PNG": 216,
	"./image/levelS/cockroach/cockroach(5).PNG": 217,
	"./image/levelS/cockroach/cockroach(6).PNG": 218,
	"./image/levelS/cockroach/cockroach(7).PNG": 219,
	"./image/levelS/cockroach/cockroach(8).PNG": 220,
	"./image/levelS/cockroach/cockroach(9).PNG": 221,
	"./image/levelS/combat/combat(1).PNG": 91,
	"./image/levelS/combat/combat(10).PNG": 222,
	"./image/levelS/combat/combat(11).PNG": 223,
	"./image/levelS/combat/combat(12).PNG": 224,
	"./image/levelS/combat/combat(13).PNG": 225,
	"./image/levelS/combat/combat(14).PNG": 226,
	"./image/levelS/combat/combat(15).PNG": 227,
	"./image/levelS/combat/combat(16).PNG": 228,
	"./image/levelS/combat/combat(17).PNG": 229,
	"./image/levelS/combat/combat(18).PNG": 230,
	"./image/levelS/combat/combat(19).PNG": 231,
	"./image/levelS/combat/combat(2).PNG": 232,
	"./image/levelS/combat/combat(20).PNG": 233,
	"./image/levelS/combat/combat(21).PNG": 234,
	"./image/levelS/combat/combat(22).PNG": 235,
	"./image/levelS/combat/combat(23).PNG": 236,
	"./image/levelS/combat/combat(24).PNG": 237,
	"./image/levelS/combat/combat(25).PNG": 238,
	"./image/levelS/combat/combat(26).PNG": 239,
	"./image/levelS/combat/combat(27).PNG": 240,
	"./image/levelS/combat/combat(28).PNG": 241,
	"./image/levelS/combat/combat(3).PNG": 242,
	"./image/levelS/combat/combat(4).PNG": 243,
	"./image/levelS/combat/combat(5).PNG": 244,
	"./image/levelS/combat/combat(6).PNG": 245,
	"./image/levelS/combat/combat(7).PNG": 246,
	"./image/levelS/combat/combat(8).PNG": 247,
	"./image/levelS/combat/combat(9).PNG": 248,
	"./image/levelS/crocodile/crocodile(1).PNG": 92,
	"./image/levelS/crocodile/crocodile(10).PNG": 249,
	"./image/levelS/crocodile/crocodile(11).PNG": 250,
	"./image/levelS/crocodile/crocodile(12).PNG": 251,
	"./image/levelS/crocodile/crocodile(13).PNG": 252,
	"./image/levelS/crocodile/crocodile(14).PNG": 253,
	"./image/levelS/crocodile/crocodile(15).PNG": 254,
	"./image/levelS/crocodile/crocodile(16).PNG": 255,
	"./image/levelS/crocodile/crocodile(17).PNG": 256,
	"./image/levelS/crocodile/crocodile(18).PNG": 257,
	"./image/levelS/crocodile/crocodile(19).PNG": 258,
	"./image/levelS/crocodile/crocodile(2).PNG": 259,
	"./image/levelS/crocodile/crocodile(20).PNG": 260,
	"./image/levelS/crocodile/crocodile(21).PNG": 261,
	"./image/levelS/crocodile/crocodile(22).PNG": 262,
	"./image/levelS/crocodile/crocodile(23).PNG": 263,
	"./image/levelS/crocodile/crocodile(24).PNG": 264,
	"./image/levelS/crocodile/crocodile(25).PNG": 265,
	"./image/levelS/crocodile/crocodile(26).PNG": 266,
	"./image/levelS/crocodile/crocodile(27).PNG": 267,
	"./image/levelS/crocodile/crocodile(28).PNG": 268,
	"./image/levelS/crocodile/crocodile(29).PNG": 269,
	"./image/levelS/crocodile/crocodile(3).PNG": 270,
	"./image/levelS/crocodile/crocodile(30).PNG": 271,
	"./image/levelS/crocodile/crocodile(31).PNG": 272,
	"./image/levelS/crocodile/crocodile(32).PNG": 273,
	"./image/levelS/crocodile/crocodile(33).PNG": 274,
	"./image/levelS/crocodile/crocodile(4).PNG": 275,
	"./image/levelS/crocodile/crocodile(5).PNG": 276,
	"./image/levelS/crocodile/crocodile(6).PNG": 277,
	"./image/levelS/crocodile/crocodile(7).PNG": 278,
	"./image/levelS/crocodile/crocodile(8).PNG": 279,
	"./image/levelS/crocodile/crocodile(9).PNG": 280,
	"./image/levelS/dinosaur/dinosaur(1).PNG": 93,
	"./image/levelS/dinosaur/dinosaur(10).PNG": 281,
	"./image/levelS/dinosaur/dinosaur(11).PNG": 282,
	"./image/levelS/dinosaur/dinosaur(12).PNG": 283,
	"./image/levelS/dinosaur/dinosaur(13).PNG": 284,
	"./image/levelS/dinosaur/dinosaur(14).PNG": 285,
	"./image/levelS/dinosaur/dinosaur(15).PNG": 286,
	"./image/levelS/dinosaur/dinosaur(16).PNG": 287,
	"./image/levelS/dinosaur/dinosaur(17).PNG": 288,
	"./image/levelS/dinosaur/dinosaur(18).PNG": 289,
	"./image/levelS/dinosaur/dinosaur(19).PNG": 290,
	"./image/levelS/dinosaur/dinosaur(2).PNG": 291,
	"./image/levelS/dinosaur/dinosaur(20).PNG": 292,
	"./image/levelS/dinosaur/dinosaur(21).PNG": 293,
	"./image/levelS/dinosaur/dinosaur(22).PNG": 294,
	"./image/levelS/dinosaur/dinosaur(23).PNG": 295,
	"./image/levelS/dinosaur/dinosaur(24).PNG": 296,
	"./image/levelS/dinosaur/dinosaur(25).PNG": 297,
	"./image/levelS/dinosaur/dinosaur(26).PNG": 298,
	"./image/levelS/dinosaur/dinosaur(3).PNG": 299,
	"./image/levelS/dinosaur/dinosaur(4).PNG": 300,
	"./image/levelS/dinosaur/dinosaur(5).PNG": 301,
	"./image/levelS/dinosaur/dinosaur(6).PNG": 302,
	"./image/levelS/dinosaur/dinosaur(7).PNG": 303,
	"./image/levelS/dinosaur/dinosaur(8).PNG": 304,
	"./image/levelS/dinosaur/dinosaur(9).PNG": 305,
	"./image/levelS/dodgem/dodgem(1).PNG": 94,
	"./image/levelS/dodgem/dodgem(10).PNG": 306,
	"./image/levelS/dodgem/dodgem(11).PNG": 307,
	"./image/levelS/dodgem/dodgem(12).PNG": 308,
	"./image/levelS/dodgem/dodgem(13).PNG": 309,
	"./image/levelS/dodgem/dodgem(14).PNG": 310,
	"./image/levelS/dodgem/dodgem(15).PNG": 311,
	"./image/levelS/dodgem/dodgem(16).PNG": 312,
	"./image/levelS/dodgem/dodgem(17).PNG": 313,
	"./image/levelS/dodgem/dodgem(18).PNG": 314,
	"./image/levelS/dodgem/dodgem(19).PNG": 315,
	"./image/levelS/dodgem/dodgem(2).PNG": 316,
	"./image/levelS/dodgem/dodgem(20).PNG": 317,
	"./image/levelS/dodgem/dodgem(21).PNG": 318,
	"./image/levelS/dodgem/dodgem(22).PNG": 319,
	"./image/levelS/dodgem/dodgem(23).PNG": 320,
	"./image/levelS/dodgem/dodgem(24).PNG": 321,
	"./image/levelS/dodgem/dodgem(25).PNG": 322,
	"./image/levelS/dodgem/dodgem(26).PNG": 323,
	"./image/levelS/dodgem/dodgem(27).PNG": 324,
	"./image/levelS/dodgem/dodgem(28).PNG": 325,
	"./image/levelS/dodgem/dodgem(29).PNG": 326,
	"./image/levelS/dodgem/dodgem(3).PNG": 327,
	"./image/levelS/dodgem/dodgem(4).PNG": 328,
	"./image/levelS/dodgem/dodgem(5).PNG": 329,
	"./image/levelS/dodgem/dodgem(6).PNG": 330,
	"./image/levelS/dodgem/dodgem(7).PNG": 331,
	"./image/levelS/dodgem/dodgem(8).PNG": 332,
	"./image/levelS/dodgem/dodgem(9).PNG": 333,
	"./image/levelS/frog/frog(1).PNG": 95,
	"./image/levelS/frog/frog(10).PNG": 334,
	"./image/levelS/frog/frog(11).PNG": 335,
	"./image/levelS/frog/frog(12).PNG": 336,
	"./image/levelS/frog/frog(13).PNG": 337,
	"./image/levelS/frog/frog(14).PNG": 338,
	"./image/levelS/frog/frog(15).PNG": 339,
	"./image/levelS/frog/frog(16).PNG": 340,
	"./image/levelS/frog/frog(17).PNG": 341,
	"./image/levelS/frog/frog(18).PNG": 342,
	"./image/levelS/frog/frog(19).PNG": 343,
	"./image/levelS/frog/frog(2).PNG": 344,
	"./image/levelS/frog/frog(20).PNG": 345,
	"./image/levelS/frog/frog(21).PNG": 346,
	"./image/levelS/frog/frog(22).PNG": 347,
	"./image/levelS/frog/frog(23).PNG": 348,
	"./image/levelS/frog/frog(24).PNG": 349,
	"./image/levelS/frog/frog(25).PNG": 350,
	"./image/levelS/frog/frog(26).PNG": 351,
	"./image/levelS/frog/frog(27).PNG": 352,
	"./image/levelS/frog/frog(28).PNG": 353,
	"./image/levelS/frog/frog(29).PNG": 354,
	"./image/levelS/frog/frog(3).PNG": 355,
	"./image/levelS/frog/frog(4).PNG": 356,
	"./image/levelS/frog/frog(5).PNG": 357,
	"./image/levelS/frog/frog(6).PNG": 358,
	"./image/levelS/frog/frog(7).PNG": 359,
	"./image/levelS/frog/frog(8).PNG": 360,
	"./image/levelS/frog/frog(9).PNG": 361,
	"./image/levelS/game/game(1).PNG": 96,
	"./image/levelS/game/game(10).PNG": 362,
	"./image/levelS/game/game(11).PNG": 363,
	"./image/levelS/game/game(12).PNG": 364,
	"./image/levelS/game/game(13).PNG": 365,
	"./image/levelS/game/game(14).PNG": 366,
	"./image/levelS/game/game(15).PNG": 367,
	"./image/levelS/game/game(16).PNG": 368,
	"./image/levelS/game/game(17).PNG": 369,
	"./image/levelS/game/game(18).PNG": 370,
	"./image/levelS/game/game(19).PNG": 371,
	"./image/levelS/game/game(2).PNG": 372,
	"./image/levelS/game/game(20).PNG": 373,
	"./image/levelS/game/game(21).PNG": 374,
	"./image/levelS/game/game(22).PNG": 375,
	"./image/levelS/game/game(23).PNG": 376,
	"./image/levelS/game/game(24).PNG": 377,
	"./image/levelS/game/game(25).PNG": 378,
	"./image/levelS/game/game(26).PNG": 379,
	"./image/levelS/game/game(27).PNG": 380,
	"./image/levelS/game/game(28).PNG": 381,
	"./image/levelS/game/game(29).PNG": 382,
	"./image/levelS/game/game(3).PNG": 383,
	"./image/levelS/game/game(30).PNG": 384,
	"./image/levelS/game/game(31).PNG": 385,
	"./image/levelS/game/game(4).PNG": 386,
	"./image/levelS/game/game(5).PNG": 387,
	"./image/levelS/game/game(6).PNG": 388,
	"./image/levelS/game/game(7).PNG": 389,
	"./image/levelS/game/game(8).PNG": 390,
	"./image/levelS/game/game(9).PNG": 391,
	"./image/levelS/insect/insect(1).PNG": 62,
	"./image/levelS/insect/insect(10).PNG": 392,
	"./image/levelS/insect/insect(11).PNG": 393,
	"./image/levelS/insect/insect(12).PNG": 394,
	"./image/levelS/insect/insect(13).PNG": 395,
	"./image/levelS/insect/insect(14).PNG": 396,
	"./image/levelS/insect/insect(15).PNG": 397,
	"./image/levelS/insect/insect(16).PNG": 398,
	"./image/levelS/insect/insect(17).PNG": 399,
	"./image/levelS/insect/insect(18).PNG": 400,
	"./image/levelS/insect/insect(19).PNG": 401,
	"./image/levelS/insect/insect(2).PNG": 402,
	"./image/levelS/insect/insect(20).PNG": 403,
	"./image/levelS/insect/insect(21).PNG": 404,
	"./image/levelS/insect/insect(22).PNG": 405,
	"./image/levelS/insect/insect(23).PNG": 406,
	"./image/levelS/insect/insect(24).PNG": 407,
	"./image/levelS/insect/insect(25).PNG": 408,
	"./image/levelS/insect/insect(26).PNG": 409,
	"./image/levelS/insect/insect(27).PNG": 410,
	"./image/levelS/insect/insect(28).PNG": 411,
	"./image/levelS/insect/insect(29).PNG": 412,
	"./image/levelS/insect/insect(3).PNG": 413,
	"./image/levelS/insect/insect(30).PNG": 414,
	"./image/levelS/insect/insect(31).PNG": 415,
	"./image/levelS/insect/insect(32).PNG": 416,
	"./image/levelS/insect/insect(33).PNG": 417,
	"./image/levelS/insect/insect(34).PNG": 418,
	"./image/levelS/insect/insect(35).PNG": 419,
	"./image/levelS/insect/insect(36).PNG": 420,
	"./image/levelS/insect/insect(37).PNG": 421,
	"./image/levelS/insect/insect(38).PNG": 422,
	"./image/levelS/insect/insect(39).PNG": 423,
	"./image/levelS/insect/insect(4).PNG": 424,
	"./image/levelS/insect/insect(40).PNG": 425,
	"./image/levelS/insect/insect(41).PNG": 426,
	"./image/levelS/insect/insect(5).PNG": 427,
	"./image/levelS/insect/insect(6).PNG": 428,
	"./image/levelS/insect/insect(7).PNG": 429,
	"./image/levelS/insect/insect(8).PNG": 430,
	"./image/levelS/insect/insect(9).PNG": 431,
	"./image/levelS/patrol/patrol(1).PNG": 97,
	"./image/levelS/patrol/patrol(10).PNG": 432,
	"./image/levelS/patrol/patrol(11).PNG": 433,
	"./image/levelS/patrol/patrol(12).PNG": 434,
	"./image/levelS/patrol/patrol(13).PNG": 435,
	"./image/levelS/patrol/patrol(14).PNG": 436,
	"./image/levelS/patrol/patrol(15).PNG": 437,
	"./image/levelS/patrol/patrol(16).PNG": 438,
	"./image/levelS/patrol/patrol(17).PNG": 439,
	"./image/levelS/patrol/patrol(18).PNG": 440,
	"./image/levelS/patrol/patrol(19).PNG": 441,
	"./image/levelS/patrol/patrol(2).PNG": 442,
	"./image/levelS/patrol/patrol(20).PNG": 443,
	"./image/levelS/patrol/patrol(21).PNG": 444,
	"./image/levelS/patrol/patrol(22).PNG": 445,
	"./image/levelS/patrol/patrol(23).PNG": 446,
	"./image/levelS/patrol/patrol(24).PNG": 447,
	"./image/levelS/patrol/patrol(25).PNG": 448,
	"./image/levelS/patrol/patrol(26).PNG": 449,
	"./image/levelS/patrol/patrol(27).PNG": 450,
	"./image/levelS/patrol/patrol(28).PNG": 451,
	"./image/levelS/patrol/patrol(29).PNG": 452,
	"./image/levelS/patrol/patrol(3).PNG": 453,
	"./image/levelS/patrol/patrol(30).PNG": 454,
	"./image/levelS/patrol/patrol(31).PNG": 455,
	"./image/levelS/patrol/patrol(32).PNG": 456,
	"./image/levelS/patrol/patrol(33).PNG": 457,
	"./image/levelS/patrol/patrol(34).PNG": 458,
	"./image/levelS/patrol/patrol(4).PNG": 459,
	"./image/levelS/patrol/patrol(5).PNG": 460,
	"./image/levelS/patrol/patrol(6).PNG": 461,
	"./image/levelS/patrol/patrol(7).PNG": 462,
	"./image/levelS/patrol/patrol(8).PNG": 463,
	"./image/levelS/patrol/patrol(9).PNG": 464,
	"./image/levelS/plane/plane(1).PNG": 98,
	"./image/levelS/plane/plane(10).PNG": 465,
	"./image/levelS/plane/plane(11).PNG": 466,
	"./image/levelS/plane/plane(12).PNG": 467,
	"./image/levelS/plane/plane(13).PNG": 468,
	"./image/levelS/plane/plane(14).PNG": 469,
	"./image/levelS/plane/plane(15).PNG": 470,
	"./image/levelS/plane/plane(16).PNG": 471,
	"./image/levelS/plane/plane(17).PNG": 472,
	"./image/levelS/plane/plane(18).PNG": 473,
	"./image/levelS/plane/plane(19).PNG": 474,
	"./image/levelS/plane/plane(2).PNG": 475,
	"./image/levelS/plane/plane(20).PNG": 476,
	"./image/levelS/plane/plane(21).PNG": 477,
	"./image/levelS/plane/plane(22).PNG": 478,
	"./image/levelS/plane/plane(23).PNG": 479,
	"./image/levelS/plane/plane(24).PNG": 480,
	"./image/levelS/plane/plane(25).PNG": 481,
	"./image/levelS/plane/plane(26).PNG": 482,
	"./image/levelS/plane/plane(27).PNG": 483,
	"./image/levelS/plane/plane(28).PNG": 484,
	"./image/levelS/plane/plane(3).PNG": 485,
	"./image/levelS/plane/plane(4).PNG": 486,
	"./image/levelS/plane/plane(5).PNG": 487,
	"./image/levelS/plane/plane(6).PNG": 488,
	"./image/levelS/plane/plane(7).PNG": 489,
	"./image/levelS/plane/plane(8).PNG": 490,
	"./image/levelS/plane/plane(9).PNG": 491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 710;